import { fromUtf8 } from "./fromUtf8.browser";
export const toUint8Array = (data) => {
    if (data instanceof Uint8Array) {
        return data;
    }
    if (typeof data === "string") {
        return fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
};
